import { ViewModel,View } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { BooleanPropertyType, IntegerPropertyType, StringPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import  { InputView } from "./input-view"


export class InputComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Input';
        this.addProperty("Text","data-b-comp-text",new StringPropertyType(this),"",false);
        this.addProperty("ReadOnly","data-b-comp-isreadonly",new BooleanPropertyType(this),false,false);
        this.addProperty("IsNumeric","data-b-comp-isnumeric",new BooleanPropertyType(this),false,false);
        this.addProperty("IsPassword","data-b-comp-ispassword",new BooleanPropertyType(this),false,false);
        this.addProperty("MaxLength","data-b-comp-maxlength",new IntegerPropertyType(this),null,false);

    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new InputElement(parent);
        return result;
    }
       
    protected getClassDefaultValue(){
        return "input";
    } 
}

export class InputElement extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new InputView();
    }
    public getTypeId(): string {
        return "VM-4D273229-F54F-4269-84C5-65144DE8945B"
    }

    public set Text(v: string) { this._Text = v; } public get Text(): string { return this._Text;} private _Text: string;
    public set ReadOnly(v: boolean) { this._ReadOnly = v; } public get ReadOnly(): boolean { return this._ReadOnly;} private _ReadOnly: boolean;
    public set IsNumeric(v: boolean) { this._IsNumeric = v; } public get IsNumeric(): boolean { return this._IsNumeric;} private _IsNumeric: boolean;
    public set IsPassword(v: boolean) { this._IsPassword = v; } public get IsPassword(): boolean { return this._IsPassword;} private _IsPassword: boolean;
    public set MaxLength(v: number) { this._MaxLength = v; } public get MaxLength(): number { return this._MaxLength;} private _MaxLength: number;
        
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitInput(this,parameter);
    }

    

}
